export default {
  title: 'Attiva le notifiche per offerte esclusive e aggiornamenti',
  description:
    'Aggiornamenti sugli ordini in tempo reale. Monitora lo stato della consegna. Promo e vantaggi esclusivi.',
  buttons: {
    confirm: 'Attiva',
    cancel: 'Non ora',
  },
};
